import { Modal } from '../../../../components/Modal/Modal';
import styles from '../styles.module.css';
import { Typography } from '@mui/material';
import { useServiceHubModal } from './useServiceHubModal';
import { Spinner } from '../../../../components/Spinner/Spinner';
import { ServiceHubForm } from './ServiceHubForm';

interface ServiceHubModalProps {
  open: boolean;
  onClose: () => void;
  selectedServiceInfoId?: string;
}

export const ServiceHubModal = ({selectedServiceInfoId, open, onClose}: ServiceHubModalProps) => {
  const {serviceHubData, loading, action, actionLoading} = useServiceHubModal(selectedServiceInfoId, onClose)

  if(loading) return (
    <Modal
      title={
        <div className={styles.modalHeader}>
          <Typography variant="h6">Service Hub</Typography>
        </div>
      }
      open={open}
      onClose={onClose}
    >
      <Spinner />
    </Modal>
  )

  return  <Modal
    shouldPreventModal
    title={
      <div className={styles.modalHeader}>
        <Typography variant="h6">Service Hub</Typography>
      </div>
    }
    open={open}
    onClose={onClose}
  >
   <ServiceHubForm
     serviceHub={serviceHubData}
     action={action} />
  </Modal>
}